export { getElementInputValue, getSerializedNodeId, hasSerializedNode, nodeAndAncestorsHaveSerializedNode, } from './serializationUtils';
export { serializeDocument } from './serializeDocument';
export { serializeNodeWithId } from './serializeNode';
export { serializeAttribute } from './serializeAttribute';
export { createSerializationStats, updateCssTextSerializationStats, aggregateSerializationStats, } from './serializationStats';
//# sourceMappingURL=index.js.map